import { CandyButton } from "../playful/CandyButton";
import { GeometricBadge } from "../playful/GeometricBadge";
import { Blob, ConfettiDecoration, StarBurst } from "../playful/Decor";
import { Reveal, useInView, reveal } from "./Reveal";
import { FINAL_CTA } from "../../copy/landing";

/** FinalCTA — conversion close. */
export default function FinalCTA() {
  const [ref, visible] = useInView(0.1);
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-20 md:px-10" data-testid="cta-section">
      <div ref={ref}>
        <div
          className="relative overflow-hidden rounded-3xl border-2 border-ink bg-ink p-10 text-white shadow-sticker-lg md:p-16"
          {...reveal(visible, 0)}
        >
          <Blob
            tone="candy"
            size={360}
            className="pointer-events-none absolute -right-20 -top-20 animate-drift opacity-40"
          />
          <Blob
            tone="yellow"
            size={180}
            className="pointer-events-none absolute -bottom-16 -left-10 animate-float opacity-30"
            style={{ animationDelay: "2s" }}
          />
          <ConfettiDecoration className="opacity-50" density="sparse" />
          <StarBurst
            tone="yellow"
            size={64}
            className="absolute right-[30%] top-10 animate-spin-slow opacity-60"
          />

          <div className="relative flex flex-col items-center gap-8 md:flex-row">
            <div className="w-full min-w-0 md:w-2/3" {...reveal(visible, 80)}>
              <GeometricBadge tone="yellow">{FINAL_CTA.badge}</GeometricBadge>
              <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.92] tracking-tight md:text-6xl xl:text-7xl">
                {FINAL_CTA.title}
                <br />
                <span className="ai-gradient-text">{FINAL_CTA.titleAccent}</span>
              </h2>
              <p className="mt-5 max-w-md font-sans text-lg leading-relaxed text-white/70">
                {FINAL_CTA.subtitle}
              </p>
            </div>
            <div
              className="flex w-full flex-col gap-3 md:w-1/3 md:items-end"
              {...reveal(visible, 200)}
            >
              <CandyButton
                to="/signup"
                variant="yellow"
                size="lg"
                withArrow
                data-testid="cta-start-free"
              >
                {FINAL_CTA.ctaPrimary}
              </CandyButton>
              <CandyButton to="/pricing" variant="paper" size="lg">
                {FINAL_CTA.ctaSecondary}
              </CandyButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
